/*
  Application events
*/
export const PF_CHROME_WEBAPP_APPLICATION_READY = 'PF_CHROME_WEBAPP_APPLICATION_READY';
export const PF_CHROME_WEBAPP_INITIATE_APPLICATION_CONTEXT = 'PF_CHROME_WEBAPP_INITIATE_APPLICATION_CONTEXT';
export const PF_CHROME_WEBAPP_UPDATE_RECIPIENT_NAMES = "PF_CHROME_WEBAPP_UPDATE_RECIPIENT_NAMES";
export const PF_CHROME_WEBAPP_MODAL_CLOSE = 'PF_CHROME_WEBAPP_MODAL_CLOSE';
export const PF_CHROME_WEBAPP_ATTACH_CONTENT = 'PF_CHROME_WEBAPP_ATTACH_CONTENT';
export const PF_CHROME_WEBAPP_POPULATE_OPPORTUNITIES = "PF_CHROME_WEBAPP_POPULATE_OPPORTUNITIES";
export const PF_CHROME_WEBAPP_ATTACH_ASSETS = "PF_CHROME_WEBAPP_ATTACH_ASSETS";
export const PF_CHROME_WEBAPP_REFRESH= "PF_CHROME_WEBAPP_REFRESH";
export const PF_CHROME_OPEN_COMPOSE = "PF_CHROME_OPEN_COMPOSE";
export const PF_CHROME_WEBAPP_POPULATE_MEETING_DETAILS = "PF_CHROME_WEBAPP_POPULATE_MEETING_DETAILS";
export const PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS = "PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS";
export const PF_ACTIVE_TAB_DETAILS = "PF_ACTIVE_TAB_DETAILS";
export const PF_GET_CURRENT_TAB_DETAILS = "PF_GET_CURRENT_TAB_DETAILS";
export const PF_CHROME_WEBAPP_POPULATE_DEAL_DETAILS = "PF_CHROME_WEBAPP_POPULATE_DEAL_DETAILS";

export const INITIATE_APPLICATION_CONTEXT = 'INITIATE_APPLICATION_CONTEXT';
/*
 Anonymous Actions
*/
export const LOGOUT_USER = 'LOGOUT_USER';
export const PF_CHROME_EXTENSION_WEBAPP_MODAL_IFRAME_LOADED = 'PF_CHROME_EXTENSION_WEBAPP_MODAL_IFRAME_LOADED';
export const PF_CHROME_EXTENSION_WEBAPP_MODAL_IFRAME_CLOSED = 'PF_CHROME_EXTENSION_WEBAPP_MODAL_IFRAME_CLOSED';
export const PF_CHROME_EXTENSION_WEBAPP_MESSAGE_REQUEST = 'PF_CHROME_EXTENSION_WEBAPP_MESSAGE_REQUEST';

/*
 Users Actions
*/
export const FETCHING_USER_ACCOUNT_REQUEST = "FETCHING_USER_ACCOUNT_REQUEST";
export const FETCHING_USER_ACCOUNT_SUCCEDDED = "FETCHING_USER_ACCOUNT_SUCCEDDED";
export const FETCHING_USER_ACCOUNT_FAILED = "FETCHING_USER_ACCOUNT_FAILED";

export const FETCHING_USER_PROFILE = 'FETCHING_USER_PROFILE';
export const FETCHING_USER_PROFILE_SUCCEEDED = 'FETCHING_USER_PROFILE_SUCCEEDED';
export const FETCHING_USER_PROFILE_FAILED = 'FETCHING_USER_PROFILE_FAILED';

/*
 Streams Actions
*/
export const FETCHING_HUB_STREAMS_REQUEST = 'FETCHING_HUB_STREAMS_REQUEST';
export const FETCHING_HUB_STREAMS_SUCCEEDED = 'FETCHING_HUB_STREAMS_SUCCEEDED';
export const FETCHING_HUB_STREAMS_FAILED = 'FETCHING_HUB_STREAMS_FAILED';

export const FETCHING_STREAM_REQUEST = 'FETCHING_STREAM_REQUEST';
export const FETCHING_STREAM_SUCCEEDED = 'FETCHING_STREAM_SUCCEEDED';
export const FETCHING_STREAM_FAILED = 'FETCHING_STREAM_FAILED';

export const FETCHING_GROUP_REQUEST = 'FETCHING_GROUP_REQUEST';
export const FETCHING_GROUP_SUCCEEDED = 'FETCHING_GROUP_SUCCEEDED';
export const FETCHING_GROUP_FAILED = 'FETCHING_GROUP_FAILED';

/*
 Collections Actions
*/
export const FETCHING_COLLECTIONS_REQUEST = 'FETCHING_COLLECTIONS_REQUEST';
export const FETCHING_COLLECTIONS_SUCCEEDED = 'FETCHING_COLLECTIONS_SUCCEEDED';
export const FETCHING_COLLECTIONS_FAILED = 'FETCHING_COLLECTIONS_FAILED';

export const FETCHING_COLLECTION_REQUEST = 'FETCHING_COLLECTION_REQUEST';
export const FETCHING_COLLECTION_SUCCEEDED = 'FETCHING_COLLECTION_SUCCEEDED';
export const FETCHING_COLLECTION_FAILED = 'FETCHING_COLLECTION_FAILED';

export const FETCHING_COLLECTION_SECTION_REQUEST = 'FETCHING_COLLECTION_SECTION_REQUEST';
export const FETCHING_COLLECTION_SECTION_SUCCEEDED = 'FETCHING_COLLECTION_SECTION_SUCCEEDED';
export const FETCHING_COLLECTION_SECTION_FAILED = 'FETCHING_COLLECTION_SECTION_FAILED';

export const GENERATE_COLLECTION_LINK_REQUEST = 'GENERATE_COLLECTION_LINK_REQUEST';
export const GENERATE_COLLECTION_LINK_SUCCEDDED = 'GENERATE_COLLECTION_LINK_SUCCEDDED';
export const GENERATE_COLLECTION_LINK_FAILED = 'GENERATE_COLLECTION_LINK_FAILED';
export const INVALIDATE_COLLECTION_LINK = 'INVALIDATE_COLLECTION_LINK';

/*
  Link Actions
*/
export const GENERATE_LINK_REQUEST = 'GENERATE_LINK_REQUEST';
export const GENERATING_LINK_SUCCEDDED = 'GENERATING_LINK_SUCCEDDED';
export const GENERATING_LINK_FAILED = 'GENERATING_LINK_FAILED';

export const GENERATE_ANONYMOUS_LINKS_REQUEST = 'GENERATE_ANONYMOUS_LINKS_REQUEST';
export const GENERATING_ANONYMOUS_LINKS_SUCCEDDED = 'GENERATING_ANONYMOUS_LINKS_SUCCEDDED';
export const GENERATING_ANONYMOUS_LINKS_FAILED = 'GENERATING_ANONYMOUS_LINKS_FAILED';

/*
Assets Actions
*/
export const GENERATE_ASSET_LINK_REQUEST = 'GENERATE_ASSET_LINK_REQUEST';
export const GENERATE_ASSET_LINK_SUCCEDDED = 'GENERATE_ASSET_LINK_SUCCEDDED';
export const GENERATE_ASSET_LINK_FAILED = 'GENERATE_ASSET_LINK_FAILED';
export const INVALIDATE_ASSET_LINK = 'INVALIDATE_ASSET_LINK';

export const FETCHING_ASSET = 'FETCHING_ASSET';
export const FETCHING_ASSET_SUCCEDDED = 'FETCHING_ASSET_SUCCEDDED';
export const FETCHING_ASSET_FAILED = 'FETCHING_ASSET_FAILED';

export const GENERATE_ASSET_LINK_BULK_REQUEST = 'GENERATE_ASSET_LINK_BULK_REQUEST';
export const GENERATE_ASSET_LINK_BULK_REQUEST_SUCCEDDED = 'GENERATE_ASSET_LINK_BULK_REQUEST_SUCCEDDED';
export const GENERATE_ASSET_LINK_BULK_REQUEST_FAILED = 'GENERATE_ASSET_LINK_BULK_REQUEST_FAILED';


export const UPDATE_ASSETS_LINK_REQUEST = 'UPDATE_ASSETS_LINK_REQUEST';
export const UPDATE_ASSETS_LINK_REQUEST_SUCCEDDED = 'UPDATE_ASSETS_LINK_REQUEST_SUCCEDDED';
export const UPDATE_ASSETS_LINK_REQUEST_FAILED = 'UPDATE_ASSETS_LINK_REQUEST_FAILED';

/*
 Configuration
*/
export const ADD_ASSET_SELECTION = "ADD_ASSET_SELECTION";
export const REMOVE_ASSET_SELECTION = "REMOVE_ASSET_SELECTION";
export const INVALIDATE_ASSETS_SELECTION = "INVALIDATE_ASSETS_SELECTION";

export const ADD_COLLECTION_SELECTION = "ADD_COLLECTION_SELECTION";
export const INVALIDATE_COLLECTION_SELECTION = "INVALIDATE_COLLECTION_SELECTION";

export const SELECT_WIDGET = 'SELECT_WIDGET';

//Search
export const SEARCHING_ASSETS_REQUEST = "SEARCHING_ASSETS_REQUEST";
export const SEARCHING_ASSETS_SUCCEEDED = "SEARCHING_ASSETS_SUCCEEDED";
export const SEARCHING_ASSETS_FAILED = "SEARCHING_ASSETS_FAILED";
export const INVALIDATE_ASSETS_SEARCH = "INVALIDATE_ASSETS_SEARCH";

//Integrations Actions
export const FETCHING_INTEGRATIONS_REQUEST = 'FETCHING_INTEGRATIONS_REQUEST';
export const FETCHING_INTEGRATIONS_SUCCEDDED = 'FETCHING_INTEGRATIONS_SUCCEDDED';
export const FETCHING_INTEGRATIONS_FAILED = 'FETCHING_INTEGRATIONS_FAILED';

//Fetch Shared Assets
export const FETCHING_SHARED_ASSETS_REQUEST = 'FETCHING_SHARED_ASSETS_REQUEST';
export const FETCHING_SHARED_ASSETS_SUCCEDDED = 'FETCHING_SHARED_ASSETS_SUCCEDDED';
export const FETCHING_SHARED_ASSETS_FAILED = 'FETCHING_SHARED_ASSETS_FAILED';

//Fetch Frequently Shared Assets
export const FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST = 'FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST';
export const FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEDDED = 'FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEDDED';
export const FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED = 'FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED';


// Configuration
export const UPDATE_ADVANCE_SETTINGS = 'UPDATE_ADVANCE_SETTINGS';

//NDA Templates
export const FETCH_ALL_NDA_TEMPLATE_REQUEST = 'FETCH_ALL_NDA_TEMPLATE_REQUEST';
export const FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED = 'FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED'; 
export const FETCHING_ALL_NDA_TEMPLATE_FAILED = 'FETCHING_ALL_NDA_TEMPLATE_FAILED';

//Fetching Seek Answer
export const FETCHING_SEEK_ANSWER = "FETCHING_SEEK_ANSWER";
export const FETCHING_SEEK_ANSWER_SUCCEEDED = "FETCHING_SEEK_ANSWER_SUCCEEDED";
export const FETCHING_SEEK_ANSWER_FAILED = "FETCHING_SEEK_ANSWER_FAILED";

//Fetching Seek Sessions
export const FETCHING_SEEKQA_SESSIONS = "FETCHING_SEEKQA_SESSIONS";
export const FETCHING_SEEKQA_SESSIONS_SUCCEEDED = "FETCHING_SEEKQA_SESSIONS_SUCCEEDED";
export const FETCHING_SEEKQA_SESSIONS_FAILED = "FETCHING_SEEKQA_SESSIONS_FAILED";

//Seek helpful
export const UPDATING_SEEK_HELPFUL = "UPDATING_SEEK_HELPFUL";
export const UPDATING_SEEK_HELPFUL_SUCCEEDED = "UPDATING_SEEK_HELPFUL_SUCCEEDED";
export const UPDATING_SEEK_HELPFUL_FAILED = "UPDATING_SEEK_HELPFUL_FAILED";

//SEEK EMAIL
export const FETCHING_EMAIL_FOR_SEEK_RESPONSE = "FETCHING_EMAIL_FOR_SEEK_RESPONSE";
export const FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED = "FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED";
export const FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED = "FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED";

//SEEK Prompts
export const FETCH_SEEK_PROMPTS = "FETCH_SEEK_PROMPTS";
export const FETCHING_SEEK_PROMPTS_SUCCEEDED = "FETCHING_SEEK_PROMPTS_SUCCEEDED";
export const FETCHING_SEEK_PROMPTS_FAILED = "FETCHING_SEEK_PROMPTS_FAILED";

//Invalidate Seek Session
export const INVALIDATE_SEEK_SESSION = "INVALIDATE_SEEK_SESSION";

//Seek Limit
export const FETCHING_SEEK_LIMIT = "FETCHING_SEEK_LIMIT";
export const FETCHING_SEEK_LIMIT_FAILED = "FETCHING_SEEK_LIMIT_FAILED";
export const FETCHING_SEEK_LIMIT_SUCCEEDED = "FETCHING_SEEK_LIMIT_SUCCEEDED";

//Login
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const AUTHENTICATE_USER_FAILED = "AUTHENTICATE_USER_FAILED";
export const AUTHENTICATE_USER_SUCCEEDED = "AUTHENTICATE_USER_SUCCEEDED";


//SSO
export const FETCH_SSO_URL = 'FETCH_SSO_URL';
export const FETCHING_SSO_URL_SUCCEEDED = 'FETCHING_SSO_URL_SUCCEEDED';
export const FETCHING_SSO_URL_FAILED = 'FETCHING_SSO_URL_FAILED';
export const INVALIDATE_SSO = 'INVALIDATE_SSO';

export const SSO_AUTHENTICATION_FAILED = 'SSO_AUTHENTICATION_FAILED';
export const SSO_AUTHENTICATION_SUCCESS = 'SSO_AUTHENTICATION_SUCCESS';

//Generate Token for SSO User
export const GENERATE_TOKEN_FOR_SSO_USER = 'GENERATE_TOKEN_FOR_SSO_USER';
export const GENERATE_TOKEN_FOR_SSO_USER_SUCCEEDED = 'GENERATE_TOKEN_FOR_SSO_SUCCEEDED';
export const GENERATE_TOKEN_FOR_SSO_USER_FAILED = 'GENERATE_TOKEN_FOR_SSO_USER_FAILED'; 

//Conversations
export const FETCHING_CONVERSATIONS_REQUEST = "FETCHING_CONVERSATIONS_REQUEST";
export const FETCHING_CONVERSATIONS_SUCCEDDED = "FETCHING_CONVERSATIONS_SUCCEDDED";
export const FETCHING_CONVERSATIONS_FAILED = "FETCHING_CONVERSATIONS_FAILED";

//Notifications
export const FETCHING_NOTIFICATIONS = "FETCHING_NOTIFICATIONS"
export const FETCHING_NOTIFICATIONS_SUCCEEDED = "FETCHING_NOTIFICATIONS_SUCCEEDED"
export const FETCHING_NOTIFICATIONS_FAILED = "FETCHING_NOTIFICATIONS_FAILED"

//Generating Link
export const GENERATING_LINK_FOR_ENTITY = "GENERATING_LINK_FOR_ENTITY"
export const GENERATING_LINK_FOR_ENTITY_SUCCEEDED = "GENERATING_LINK_FOR_ENTITY_SUCCEEDED"
export const GENERATING_LINK_FOR_ENTITY_FAILED = "GENERATING_LINK_FOR_ENTITY_FAILED"

export const INVALIDATE_GENERATE_LINK = "INVALIDATE_GENERATE_LINK"

export const UPDATE_RECIPIENT_NAMES = "UPDATE_RECIPIENT_NAMES";
export const UPDATE_RECIPIENT_NAMES_SUCCEDDED = "UPDATE_RECIPIENT_NAMES_SUCCEDDED";
export const UPDATE_RECIPIENT_NAMES_FAILED = "UPDATE_RECIPIENT_NAMES_FAILED";

//search streams
export const SEARCHING_STREAMS_REQUEST = "SEARCHING_STREAMS_REQUEST";
export const SEARCHING_STREAMS_SUCCEEDED = "SEARCHING_STREAMS_SUCCEEDED";
export const SEARCHING_STREAMS_FAILED = "SEARCHING_STREAMS_FAILED";
export const INVALIDATE_STREAMS_SEARCH = "INVALIDATE_STREAMS_SEARCH";

//search collections
export const SEARCHING_COLLECTIONS_REQUEST = "SEARCHING_COLLECTIONS_REQUEST";
export const SEARCHING_COLLECTIONS_SUCCEEDED = "SEARCHING_COLLECTIONS_SUCCEEDED";
export const SEARCHING_COLLECTIONS_FAILED = "SEARCHING_COLLECTIONS_FAILED";
export const INVALIDATE_COLLECTIONS_SEARCH = "INVALIDATE_COLLECTIONS_SEARCH";

//search recommended assets
export const FETCHING_RECOMMENDED_ASSETS_REQUEST = "FETCHING_RECOMMENDED_ASSETS_REQUEST";
export const FETCHING_RECOMMENDED_ASSETS_SUCCEEDED = "FETCHING_RECOMMENDED_ASSETS_SUCCEEDED";
export const FETCHING_RECOMMENDED_ASSETS_FAILED = "FETCHING_RECOMMENDED_ASSETS_FAILED";
export const INVALIDATE_RECOMMENDED_ASSETS = "INVALIDATE_RECOMMENDED_ASSETS";

//attach and invalidate assets and settings in compose
export const UPDATE_ATTACH_CONTENT = "UPDATE_ATTACH_CONTENT";
export const INVALIDATE_ATTACH_CONTENT = "INVALIDATE_ATTACH_CONTENT";
export const INVALIDATE_SETTINGS = "INVALIDATE_SETTINGS";

//fetch conversation activity
export const FETCHING_CONVERSATION_ACTIVITY_REQUEST = "FETCHING_CONVERSATION_ACTIVITY_REQUEST";
export const FETCHING_CONVERSATION_ACTIVITY_REQUEST_SUCCEEDED = "FETCHING_CONVERSATION_ACTIVITY_REQUEST_SUCCEEDED";
export const FETCHING_CONVERSATION_ACTIVITY_REQUEST_FAILED = "FETCHING_CONVERSATION_ACTIVITY_REQUEST_FAILED"; 
export const INVALIDATE_CONVERSATION_ACTIVITY = "INVALIDATE_CONVERSATION_ACTIVITY";

export const SET_ACTIVE_CRM = "SET_ACTIVE_CRM";

export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";

export const ACTIVATED_GMAIL_INTEGRATION = "ACTIVATED_GMAIL_INTEGRATION";

export const REDIRECT_URL = "REDIRECT_URL";

//Trigger capability activation
export const CAPABILITY_ACTIVATION = "CAPABILITY_ACTIVATION";

// fetch deals
export const FETCH_DEALS = "FETCH_DEALS";
export const FETCHING_DEALS_SUCCEEDED = "FETCHING_DEALS_SUCCEEDED";
export const FETCHING_DEALS_FAILED = "FETCHING_DEALS_FAILED";

// fetch company
export const FETCH_COMPANY = "FETCH_COMPANY";
export const FETCHING_COMPANY_SUCCEEDED = "FETCHING_COMPANY_SUCCEEDED";
export const FETCHING_COMPANY_FAILED = "FETCHING_COMPANY_FAILED";

// fetch stakeholders
export const FETCH_STAKEHOLDERS = "FETCH_STAKEHOLDERS";
export const FETCHING_STAKEHOLDERS_SUCCEEDED = "FETCHING_STAKEHOLDERS_SUCCEEDED";
export const FETCHING_STAKEHOLDERS_FAILED = "FETCHING_STAKEHOLDERS_FAILED";

export const FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST = "FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST";
export const FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_SUCCEEDED = "FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_SUCCEEDED";
export const FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_FAILED = "FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_FAILED";

export const FETCH_SHARES_FOR_STAKEHOLDERS = "FETCH_SHARES_FOR_STAKEHOLDERS";
export const FETCHING_SHARES_FOR_STAKEHOLDERS_SUCCEEDED = "FETCHING_SHARES_FOR_STAKEHOLDERS_SUCCEEDED";
export const FETCHING_SHARES_FOR_STAKEHOLDERS_FAILED = "FETCHING_SHARES_FOR_STAKEHOLDERS_FAILED";

// invalidate meeting details
export const INVALIDATE_MEETING_DETAILS = "INVALIDATE_MEETING_DETAILS";

export const POPULATE_MEETING_DETAILS = "POPULATE_MEETING_DETAILS";

export const POPULATE_DEAL_DETAILS = "POPULATE_DEAL_DETAILS";

export const INVALIDATE_DEAL_DETAILS = "INVALIDATE_DEAL_DETAILS";

export const FETCH_SIMILAR_DEALS = "FETCH_SIMILAR_DEALS";
export const FETCHING_SIMILAR_DEALS_SUCCEEDED = "FETCHING_SIMILAR_DEALS_SUCCEEDED";
export const FETCHING_SIMILAR_DEALS_FAILED = "FETCHING_SIMILAR_DEALS_FAILED";
export const INVALIDATE_SIMILAR_DEALS = "INVALIDATE_SIMILAR_DEALS";

// fetch deal rooms for stakeholders
export const FETCH_DEAL_ROOMS_FOR_STAKEHOLDERS = "FETCH_DEAL_ROOMS_FOR_STAKEHOLDERS";
export const FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_SUCCEEDED = "FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_SUCCEEDED";
export const FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_FAILED = "FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_FAILED";
export const INVALIDATE_DEAL_ROOMS_FOR_STAKEHOLDERS = "INVALIDATE_DEAL_ROOMS_FOR_STAKEHOLDERS";